{
  "errors": {
    "accessCodeNotFound": "Access code not found",
    "incorrectPin": "Incorrect PIN",
    "loginFailed": "Oops! That didn't work. Try again!"
  },
  "accessCode": {
    "title": "Welcome to Curipop!",
    "subtitle": "Enter your family access code to start",
    "label": "Family Access Code",
    "placeholder": "ABC1234",
    "helper": "3 letters + 4 numbers (e.g., ABC1234)",
    "checking": "Checking...",
    "cta": "Let's Go!",
    "help": "Don't have a code? Ask a parent!"
  },
  "selectChild": {
    "title": "Who's Learning Today?",
    "subtitle": "Choose your profile to continue",
    "grade": "Grade {grade}",
    "backSuffix": "to Access Code"
  },
  "enterPin": {
    "title": "Hi {name}!",
    "subtitle": "Enter your secret PIN",
    "remember": "Remember this device",
    "backSuffix": "to Choose Profile",
    "help": "Forgot PIN? Ask your parent!"
  },
  "legacy": {
    "title": "Kids Login",
    "subtitle": "Ask your parent for help!",
    "nameLabel": "Your Name",
    "namePlaceholder": "Type your name...",
    "pinLabel": "Secret PIN",
    "pinPlaceholder": "••••",
    "cta": "Let's Go!",
    "help": "Need help? Ask your parent or teacher!",
    "parentLogin": "Parent Login"
  }
}
